'use strict';
import angular from 'angular';

angular.module('dashboardfilterpanel.constants', [])
    .constant('DashboardFilterEvents', {
      FILTERS_UPDATED: 'DashboardFilterEvents:FiltersUpdated'
    });